// extracted by mini-css-extract-plugin
module.exports = {"box":"text_box__KXpBO"};